import { ValidatorFn, AbstractControl } from '@angular/forms';

export function customFnValidatorFn(hasError: () => boolean, errorName: string): ValidatorFn {
  return (
    control: AbstractControl
  ): {
    [key: string]: any;
  } | null => {
    if (hasError()) {
      let error = {};
      error[errorName] = { value: control.value };
      return error;
    }
    return null;
  };
}
